import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["variablesToolbar", "trixEditor"];

  connect() {
    this.variables = JSON.parse(this.element.dataset.notificationsCenterVariables || '[]');
    if (this.hasVariablesToolbarTarget) {
      this.renderVariablesToolbar();
    }
  }

  renderVariablesToolbar() {
    const select = document.createElement('select');
    select.className = 'form-control form-control-sm w-auto';

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Inserir variável...';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    this.variables.forEach(variable => {
      const option = document.createElement('option');
      option.value = `{{${variable.value}}}`;
      option.textContent = variable.title;
      select.appendChild(option);
    });

    select.addEventListener('change', () => {
      if (select.value) {
        this.insertVariable(select.value);
        select.value = '';
      }
    });

    this.variablesToolbarTarget.appendChild(select);
  }

  insertVariable(value) {
    if (!this.hasTrixEditorTarget) return;
    this.trixEditorTarget.editor.insertString(value);
    this.trixEditorTarget.focus();
  }
}
